import React from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";
import { Select } from "components/forms";
import { IUsersContact } from "store/types";

interface Props {
  selectedUsers: Array<IUsersContact>;
  setSelectedUsers: (users: Array<IUsersContact>) => void;
  shareType: "guest" | "viewer";
  setShareType: (type: "guest" | "viewer") => void;
  message: string;
  setMessage: (msg: string) => void;
  showMembers: boolean;
  onShowMembers: () => void;
  messageError?: string;
  sharableUsers: IUsersContact[];
}
export const ShareContent = (props: Props) => {
  return (
    <div className="documents__share-popup">
      <Autocomplete
        size="small"
        multiple={true}
        value={props.selectedUsers}
        options={props.sharableUsers}
        onChange={(e, value) => props.setSelectedUsers(value as IUsersContact[])}
        getOptionLabel={(option) => option.full_name}
        renderInput={(params) => <TextField {...params} fullWidth placeholder="Add User" />}
      />
      <Select
        items={[
          { key: "guest", text: "Guest", value: "guest" },
          { key: "viewer", text: "Viewer", value: "viewer" }
        ]}
        sx={{ borderRadius: "8px", height: "42px" }}
        variant="outlined"
        value={props.shareType}
        label=""
        onChange={(e) => props.setShareType(e.target.value as "guest" | "viewer")}
      />
      <TextField
        sx={{ gridColumn: "1 / span 2" }}
        multiline
        rows={4}
        value={props.message}
        placeholder="Message"
        onChange={(e) => props.setMessage(e.target.value)}
        error={!!props.messageError}
        helperText={props.messageError}
      />
      {props.showMembers && (
        <Typography variant="body2" className="documents__members-btn" onClick={props.onShowMembers}>
          Show Members
        </Typography>
      )}
    </div>
  );
};
